<template>
<!-- Comparism Section Starts Here ehealth4everyone -->
  <span>
    <!-- <draggable v-model="myArray"
        :options="{group:'widgets', handle: '.glyphicon-move', animation: 150}"
        @start="drag=true" @end="drag=false"> -->
      <!-- <transition-group tag="div" name="slide"> -->
    <div class="col-xs-12 col-md-4 compare-indicators" v-for="(indicator_value, key) in relativeIndicatorsValues" :key="key"  style="margin-top: 2px;">
      <div class="panel panel-primary widget" :id="'widget_' + key">
        <div class="panel-heading">
          <!-- <span class="glyphicon glyphicon-stats" aria-hidden="true" v-tooltip.top="'drag'" style="visibility: hidden;"></span> -->
          <div class="row compare-panel-switch">
            <div @click="expandedBool(indicator_value,key)" class="col-xs-2 comparison-options">
              <span style="">EXPAND</span>
              <v-icon>zoom_out_map</v-icon>
            </div>

            <div @click="changeComponent('zones',key)" class="col-xs-offset-2 col-xs-2 comparison-options">
              <span style="">ZONES MAP</span>
              <v-icon>fas fa-map-marker</v-icon>
            </div>

            <div @click="changeComponent('states',key)" class="col-xs-2 comparison-options compare-option-selected">
              <span style="">STATES MAP</span>
              <v-icon>fas fa-map-marker</v-icon>
            </div>

            <div @click="changeComponent('line',key)" class="col-xs-2 comparison-options">
              <span style="">LINE CHART</span>
              <v-icon>show_chart</v-icon>
            </div>

            <div @click="changeComponent('column',key)" class="col-xs-2 comparison-options">
              <span style="">COLUMN CHART</span>
              <v-icon>bar_chart</v-icon>
            </div>
          </div>
        </div>
        <div class="row panel-body">
          <plot-map v-show="componentType[key]==='Map'" :masterIndicator="selectedIndicator" :relativeIndicator="relativeIndicators[key]" :indicatorOptions="optionIndicators"
                    :appData="appData" :mapType="specificMapType[key]" :isExpanded="expandedBoolVal[key]" v-on:expanded="changeExpandedBoolVal(key)"
                    v-on:indicatorClicked="indicatorMultiselectChanged(key,$event)" :indicatorClicked="multiselectIndicator[key]" 
                    @sourceSelected="sourceMultiselectChanged(key,$event)" :sourceSelected="sourcesSelected[key]">
          </plot-map>
          <plot-chart v-show="componentType[key]==='Charts'" :masterIndicator="selectedIndicator" :relativeIndicator="relativeIndicators[key]" :indicatorOptions="optionIndicators"
                      :appData="appData" :selectedState="selectedState" :isExpanded="expandedBoolVal[key]" :chartType="specificChartType[key]"
                      v-on:expanded="changeExpandedBoolVal(key)" v-on:indicatorClicked="indicatorMultiselectChanged(key,$event)"
                      :indicatorClicked="multiselectIndicator[key]" @sourceSelected="sourceMultiselectChanged(key,$event)" :sourceSelected="sourcesSelected[key]">
          </plot-chart>
          <!-- :data="[indicator_value, relativeIndicators[key], dataSources, selectedYear,comparismType,selectedIndicator,appData,singleMapSource]" -->
        </div>
      </div>

    </div>
        <!-- </transition-group> -->
      <!-- </draggable> -->
  </span>
</template>

<script>

import PlotMap from './maptypes'
import PlotChart from './chartTypes'
export default {
  name: 'compare-section',
  props: ['relativeIndicatorsValues', 'singleMapSource','selectedIndicator', 'compType', 'dataSources', 'comparismType', 'regionalChartYearOptionsData',
          'optionIndicators', 'relativeIndicators','appData','selectedState'],
  components: {
    PlotMap, PlotChart
  },
  data() {
    return {
      // componentType: "Charts",
      specificComponentOptions: ["line", "column"],
      specificComponentType: "line",
      component: 'line',
      indicatorForMapAndChart: [],
      componentType: ['Map','Map','Map'],
      specificMapType: ['states', 'states', 'states'],
      specificChartType: ['line', 'line', 'line'],
      selectedYear: null,
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      expandedBoolVal: [false,false,false],
      compareSectionKey: '',
      // sourceSelected: '',
      compareSectionIndicatorValue: '',
      expandedView: false,
      multiselectIndicator: ['','',''],
      sourcesSelected: ['','','']
    }
  },
  methods: {
    dropdownChangedChart(value, key) {
      this.specificChartType[key] = value;
    },
    expandedBool (indicator_value,key){
      this.expandedBoolVal.splice(key,1,true);
      this.compareSectionKey = key;
      this.compareSectionIndicatorValue = indicator_value;
      this.expandedView = true;
    },
    closeExpandedBool(val){
      //this.expandedBoolVal[val] = !this.expandedBoolVal[val];
      this.expandedBoolVal = [false, false, false];
      this.expandedView = false;
    },
    changeExpandedBoolVal(key){
      this.expandedBoolVal.splice(key,1,false);
    },
    computeIndicatorSelected(key,e){
      this.indicatorForMapAndChart[key] = e;
    },
    indicatorMultiselectChanged(key,e){      
      this.multiselectIndicator.splice(key,1,e);      
    },
    sourceMultiselectChanged(key,e){   
      this.sourcesSelected.splice(key,1,e);      
      // this.sourceSelected = e;
      
    },
    /** Changes the component type using slice
     * (simply modifying will not trigger the watch on the child component)
    */
    changeComponent(type,key){
      this.specificComponentType = type;
      if(type === 'zones' || type === 'states'){
        // this.componentType[key] = 'Map';
        //console.log(key)
        this.componentType.splice(key,1,'Map');
        this.specificMapType[key] = type;
      } else {
        // this.componentType[key] = 'Charts';
        this.componentType.splice(key,1,'Charts');
        this.specificChartType[key] = type;
      }
      this.$emit('componentTypeArray',this.componentType)
    },
    dropdownChangedMap(value, key) {
      this.specificMapType[key] = value;
      // this.specificMapType = value
    },
    compareSectionClicked(){
      //Event listener to change background color of clicked div
      // console.log("This won't be styled: " + '%c' + "Yay i was called", 'color: red; font-weight: bold; background-color: yellow; padding: 10px;')
      let sections = document.querySelectorAll('.comparison-options');
      if(sections.length > 0){
        let section1 = [],
            section2 = [],
            section3 = [];
        for(var i in sections){
          if(i<5){
            section1.push(sections[i]);
          } else if (i>4 && i < 10){
            section2.push(sections[i]);
          } else if(i > 9 && i < sections.length){
            section3.push(sections[i]);
          }
        }
        sections.forEach((section,index) => {
          section.addEventListener('click',() => {
            if(index < 5){
              section1.forEach((el) => {
                if(el.className.indexOf(' compare-option-selected') > 0){
                  el.className = el.className.replace(' compare-option-selected','');
                }
              });
            } else if (index>4 && index < 10){
              section2.forEach((el) => {
                if(el.className.indexOf(' compare-option-selected') > 0){
                  el.className = el.className.replace(' compare-option-selected','');
                }
              });
            } else if (index > 9 && index < sections.length) {
              section3.forEach((el) => {
                if(el.className.indexOf(' compare-option-selected') > 0){
                  el.className = el.className.replace(' compare-option-selected','');
                }
              });
            }
            section.className += ' compare-option-selected'
          });
        });
      }
    }
  },
  mounted(){
    if(this.appData){
      this.lsData = this.appData;
    }
    //console.log(this.relativeIndicatorsValues);
    
    this.indicatorForMapAndChart = this.relativeIndicators;
  },
  computed: {
    /**
     * Get the source clicked/checked on the table
     *@param none
     *@returns sourceclicked | indicatorSource: String
     */
    // sourceClicked() {
    //   var tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
    //   var sources = tableColumnHeaderAttr[0];
    //   var val = tableColumnHeaderAttr[1];var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
    //   var indicatorSource = this.selectedIndicator + " -> " + sources;
    //   if(this.lsData){
    //     var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
    //     // check for availability of data in the source here
    //     var defaultSource = this.$store.getters.getDefaultSource;
    //     var selectedSource = defaultSource; //statesWithIndicatorsYearAndValues[1] > 0 ? sources:
    //     let data = this.lsData.slice(1);
    //     for(var i in data){
    //         if(data[i][indexOfindicatorSource] !== "" && indexOfindicatorSource > 0){
    //           selectedSource = sources;
    //           break;
    //         } else {
    //           selectedSource = defaultSource;
    //           continue;
    //         }
    //     }
    //     // get the state indicator source object from store
    //     var stateSelectedIndicatorSource = this.$store.getters.getSelectedIndicatorSource;
    //     var selectedIndicatorSource = stateSelectedIndicatorSource[selectedSource];

    //     if (selectedIndicatorSource) {
    //       // compute the years custom to the data
    //       var optionYear = [];
    //       Object.keys(stateSelectedIndicatorSource).map( (elem, index) => {
    //           if (stateSelectedIndicatorSource[elem].length > 0) {
    //               optionYear.push(stateSelectedIndicatorSource[elem][0])
    //           }
    //       })
    //       //this.optionYear = optionYear; // assign to select year field
    //       // get the indicator selected, and watch the year of its current value.
    //       if (selectedIndicatorSource.length > 0) {
    //         this.selectedYear = selectedIndicatorSource[0];
    //       }
    //     }
    //     return selectedSource;
    //   }
    // }
  },
  updated() {
    // Method call for event listener 
   this.compareSectionClicked();
  },
  watch: {
    selectedIndicator(val){
      //console.log(val);
    },
    relativeIndicators(val){
      //console.log(val);
      this.indicatorForMapAndChart = val;
    },
    // specificComponentType(val){
    //   if(val === 'line' || val === 'column'){
    //    this.componentType = 'Charts'
    //   } else {
    //     this.componentType = 'Map'
    //   }
    //   console.log(this.componentType)
    // },
    componentType(val){
      if(val==="Map"){
        this.specificComponentOptions = ["states", "zones"];
        this.specificComponentType = "states";
      }else {
        this.specificComponentOptions = ["line", "column"];
        this.specificComponentType = "line";
      }
    },
    appData(val){
      if(val){
        this.lsData = val;
      }
    },
    compType(val){
    }
  },
}
</script>



// WEBPACK FOOTER //
// compareSection.vue?7857625a